<template>
	<div class="container">
		<div v-html="coupon.body"></div>
	</div>
</template>

<script>
export default {
	props: ["coupon"]
};
</script>

<style lang="scss">
</style>